import { render, staticRenderFns } from "./PageType.vue?vue&type=template&id=2bdc0508"
import script from "./PageType.vue?vue&type=script&lang=js"
export * from "./PageType.vue?vue&type=script&lang=js"
import style0 from "./PageType.vue?vue&type=style&index=0&id=2bdc0508&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports